// SUN-174: vendor <-> product links. Shared by the Vendors drawer, the Add window and the
// Raw Materials "Vendors" block. The server decides who may edit and hides rates from sales
// (rate / lastPo.unitPrice arrive as null) - this file only shapes what is shown.
import { isMasterdataApprover } from '@/lib/masterdataApprovers';

export const LINK_UNITS = ['PCS', 'KGS', 'LTR', 'MTR', 'SQM', 'SET'];

export interface VendorLink {
  id: string;
  productId: string;
  product: { name: string; sku?: string | null; type?: string | null };
  vendorItemCode?: string | null;
  rate?: number | string | null;
  unit?: string | null;
  leadTimeDays?: number | null;
  isPreferred: boolean;
}

export interface ProductLink {
  id: string;
  vendorId: string;
  vendor: { name: string; gstin?: string | null };
  vendorItemCode?: string | null;
  rate?: number | string | null;
  unit?: string | null;
  leadTimeDays?: number | null;
  isPreferred: boolean;
  lastPo?: { date: string; unitPrice?: number | string | null } | null;
}

/** Edit / remove / make-preferred buttons: admin, owner and the masterdata approvers (buyer, store keeper, accounts). */
export const canEditLinks = (user: { role?: { name?: string | null } | null } | null | undefined) => isMasterdataApprover(user);

const hasValue = (v: unknown) => v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v));

/** null stays a dash - never "₹null" or a made-up 0. A real 0 from the server is shown. */
export const fmtRate = (v: number | string | null | undefined) =>
  hasValue(v) ? Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';

export const fmtLead = (d: number | null | undefined) => (d === null || d === undefined ? '—' : `${d} ${d === 1 ? 'day' : 'days'}`);

export const fmtLastPo = (po: ProductLink['lastPo']) => {
  if (!po) return '—';
  const date = new Date(po.date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata' });
  return hasValue(po.unitPrice) ? `${date} · ₹${Number(po.unitPrice).toLocaleString('en-IN')}` : date;
};

export const apiError = (e: any, fallback: string): string =>
  e?.response?.data?.error || e?.response?.data?.message || fallback;
